namespace GeniuzPOS.ReportMasterData {
    export class Report1332ShopPaymentTypeRefTypeColumns {
        static columnsKey = 'ReportMasterData.Report1332ShopPaymentTypeRefType';
    }
}
